document.addEventListener('alpine:init', () => {
  var { getStylesheet } = Alpine.store('utilities');

  function productReviews(data = {}) {
    return {
      ...data,
  
      isIntersected: false,
  
      onIntersect() {
        this.isIntersected = true;

        this.$nextTick(() => {
          this.initJudgeMeWidgetJS();
          this.initJudgeMeWidgetCSS();

          if (window.global.settings.mode == 'development') {
            setTimeout(() => {
              this.initJudgeMeWidgetJS();
            }, 500);
          }
        });
      },

      initJudgeMeWidgetCSS() {
        var stylesheetUrl = window.global.assetUrl['judgeme.css'];

        getStylesheet(stylesheetUrl);
      
        if (window.jdgmLoadCSS || document.querySelectorAll('.jdgm-widget, .jdgm-all-reviews-page').length) {
          if (jdgmSettings.widget_load_with_code_splitting) {
            if (parseFloat(jdgmSettings.widget_version) >= 3) {
              jdgm.loadCSS(`${jdgm.CDN_HOST}widget_v3/base.css`);
            } else {
              jdgm.loadCSS(`${jdgm.CDN_HOST}widget/base.css`);
            }
          } else {
            jdgm.loadCSS(`${jdgm.CDN_HOST}shopify_v2.css`);
          }
        }
      },

      initJudgeMeWidgetJS() {
        if (window.jdgmLoadCSS || document.querySelectorAll('.jdgm-widget, .jdgm-all-reviews-page').length) {
          jdgm.loadJS(`${jdgm.CDN_HOST}loader.js`);
        }        
      }
    };
  };

  Alpine.data('productReviews', productReviews);
});
